// A read result that can be pending, loaded, or failed. Pulled out of
// `AssignmentsScreen.tsx` into its own module so it is importable from a test
// without pulling in a React component (`vitest.config.ts` runs with no DOM,
// and a file that exports a component alongside plain functions/constants
// trips the `react-refresh/only-export-components` lint rule anyway).
//
// The bug this replaces: a single `loading = a === null || b === null` flag
// that a read failure never cleared, because the catch set only a banner —
// so a failed load looked exactly like a permanent spinner, forever. Naming
// the three states explicitly makes them impossible to conflate.
export type ReadState<T> =
  | { kind: 'pending' }
  | { kind: 'loaded'; data: T }
  | { kind: 'failed'; error: string }

export const PENDING: ReadState<never> = { kind: 'pending' }

/** The groups area's state, derived from one or more independent reads.
    Pending wins over failed (still waiting on another source); otherwise a
    failure on any source is a failure, in place of the groups. */
export function pageState(...reads: ReadState<unknown>[]): 'pending' | 'failed' | 'ready' {
  if (reads.some((r) => r.kind === 'pending')) return 'pending'
  if (reads.some((r) => r.kind === 'failed')) return 'failed'
  return 'ready'
}
